import { render, staticRenderFns } from "./Front-Header.vue?vue&type=template&id=51e45acd&"
import script from "./Front-Header.vue?vue&type=script&lang=js&"
export * from "./Front-Header.vue?vue&type=script&lang=js&"
import style0 from "./Front-Header.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports